import React from 'react';

export default (props) => (
    <svg width="18" height="18" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ paddingBottom: 3, marginRight: 10}}>
        <circle cx="12" cy="12" r="8"
            fill={props.fill || "Black"}
        />
    </svg>
);